
import React, { useState } from 'react';
import { useAuth } from '../hook/useAuth'
import { useNavigate, useLocation } from 'react-router-dom';


import TextField from '@mui/material/TextField';
import Button from '@mui/material/Button';


const Connexion = () => {

    const [username, setUserName] = useState('')
    const [password, setPassword] = useState('')

    const {signin} = useAuth();

    const navigate = useNavigate()
    const location = useLocation()

    const checkLocation = ()=>{
        let url = '/'
        if(location){
            console.log(location)
        }

        return url

    }

    const connexion = async () => {

       await signin({'username':username, 'password':password}, () => navigate(checkLocation(), {replace: true}));

    }

    return (

        <>
            <div style={{ marginTop: '50px', }}>
                <TextField
                    id="outlined-search"
                    label="User"
                    type="text"
                    InputLabelProps={{
                        shrink: true,
                    }}
                    style={{ 
                        width: '200px', 
                        // position: 'relative', 
                        top: '50%',
                        left: '50%',
                        margin: '0 -100px 0 -100px'  }}

                    value={username}
                    onChange={(e) => setUserName(e.target.value)}
                />
            </div>
            <div style={{ marginTop: '20px', marginLeft: '50%', marginRight: '50%' }}>
                <TextField
                    id="outlined-password-input"
                    label="Password"
                    type="password"
                    name="password"
                    InputLabelProps={{
                        shrink: true,
                    }}
                    style={{ 
                        width: '200px', 
                        // position: 'relative', 
                        top: '50%',
                        left: '50%',
                        margin: '0 -100px 0 -100px'  }}
                    value={password}
                    onChange={(e) => setPassword(e.target.value)}
                />
                <div style={{ marginTop: '20px', marginLeft: '50%', marginRight: '50%' }}>
                    <Button

                        variant="outlined"
                        size="large"
                        style={{ 
                            width: '200px', 
                            // position: 'relative', 
                            top: '50%',
                            left: '50%',
                            margin: '0 -100px 0 -100px'  }}

                        onClick={() => connexion()}>ok</Button>
                </div>
            </div>
        </>
    );
};

export default Connexion;